module.exports = __webpack_public_path__ + "img/icone_icone_4.646dbefe.svg";